import {
  QueryResult,
  QueryTuple,
  gql,
  useLazyQuery,
  useQuery,
} from '@apollo/client';
import { TENANT_FRAGMENT } from '../fragments';

const GET_MY_TENANT_QUERY = gql`
  query {
    getMyTenant {
      ...Tenant
    }
  }
  ${TENANT_FRAGMENT}
`;

interface GetMyTenantOutput {
  getMyTenant: {
    id: string;
    name: string;
    street: string;
    city: string;
    zipCode: string;
    country: string;
    taxId: string;
    dashboardId: string;
    logoUrl?: string;
  };
}

function useGetMyTenantQuery(): QueryResult<GetMyTenantOutput> {
  return useQuery<GetMyTenantOutput>(GET_MY_TENANT_QUERY);
}

function useGetMyTenantLazyQuery(): QueryTuple<
  GetMyTenantOutput,
  {
    [x: string]: unknown;
  }
> {
  return useLazyQuery<GetMyTenantOutput>(GET_MY_TENANT_QUERY);
}

export type { GetMyTenantOutput };
export { useGetMyTenantQuery, useGetMyTenantLazyQuery };
